import React from "react";
import "../styles/typography.css";
import styles from "../styles/ChatClassification.module.css";
import { getAssetBaseUrl } from "../config";

interface ChatHeaderProps {
  onMinimize?: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({ onMinimize }) => {
  return (
    <header className={styles.chatHeader}>
      <div className={styles.headerLeft}>
        <img
          src={`${getAssetBaseUrl()}images/chatbot_design_grafico.svg`}
          alt="Chatbot Design"
          className={styles.headerIcon}
        />
        <h2 className={styles.headerTitle}>Assistente Virtual</h2>
      </div>

      {onMinimize && (
        <button
          type="button"
          className={styles.minimizeButton}
          onClick={onMinimize}
          aria-label="Minimizar chat"
          title="Minimizar"
        >
          &#x2212;
        </button>
      )}
    </header>
  );
};

export default ChatHeader;
